import { createModel } from "@rematch/core";
import { KoreModel } from "./";
import { Dispatch } from "redux";
import axios from "axios";

export interface SessionConfigs {
  locale: string;
  contactId: number;
  IdClient: number;
  IdLogin: number;
  SessionId: number;
  admin: boolean;
  configRight: boolean;
  Permissions: Record<string, number>;
}

const model = {
  name: "sessionConfigs",
  state: {} as SessionConfigs,
  reducers: {
    setData: (currentState: SessionConfigs, data: SessionConfigs) => {
      return { ...data };
    }
  },
  effects: (dispatch: Dispatch) => {
    return {
      async getData() {
        const { data } = await axios.get("/Config/getVars");

        if (data) dispatch.sessionConfigs.setData(data);
      }
    };
  }
};

export const sessionConfigsModel = createModel<KoreModel>()(model);
